/* ==========================================================================
   Maccs — mobile sticky add bar
   position:fixed, not sticky: Envy sets body{overflow-x:hidden}, which breaks
   position:sticky globally. Moved to <body> so Slideout's transform on
   #main-body can't reparent it.
   ========================================================================== */

(function () {
  'use strict';

  var bar = document.querySelector('[data-mx-stickybar]');
  var purchase = document.getElementById('purchase');
  var priceField = document.getElementById('price-field');
  if (!bar || !purchase || !priceField) return;

  document.body.appendChild(bar);

  var meta = bar.querySelector('[data-mx-stickybar-meta]');
  var addBtn = bar.querySelector('[data-mx-stickybar-add]');
  var qtyInput = document.getElementById('Quantity');

  function selectedPack() {
    var checked = document.querySelector('.mx-pack input:checked');
    if (!checked) return '';
    var label = document.querySelector('label[for="' + checked.id + '"] .mx-pack__name');
    return label ? label.textContent.trim() : checked.value;
  }

  function updateMeta() {
    var bits = [];
    var pack = selectedPack();
    if (pack) bits.push(pack);
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (qty > 1) bits.push('qty ' + qty);
    /* Members see their price in the bar, not the struck-through regular. */
    var memberEl = document.querySelector('[data-mx-member-price]');
    var price = memberEl && memberEl.textContent.trim()
      ? memberEl.textContent.trim()
      : priceField.textContent.trim();
    if (price) bits.push(price);
    meta.textContent = bits.join(' \u00b7 ');
  }

  /* Show once the real Add to Cart button has scrolled out of view. */
  function updateVisibility() {
    var rect = purchase.getBoundingClientRect();
    var passed = rect.bottom < 0;
    bar.hidden = !passed;
    document.body.classList.toggle('mx-has-stickybar', passed);
  }

  addBtn.addEventListener('click', function () {
    purchase.click();
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);

  var $ = window.jQuery;
  if ($) $(document).on('variantAvailable variantUnavailable', function () { setTimeout(updateMeta, 0); });

  if (qtyInput) {
    qtyInput.addEventListener('change', updateMeta);
    var controls = qtyInput.closest('.quantity-controls');
    if (controls) controls.addEventListener('click', function () { setTimeout(updateMeta, 0); });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest('.mx-pack')) setTimeout(updateMeta, 0);
  });

  updateMeta();
  updateVisibility();
})();